import { render, staticRenderFns } from "./ModalJustificativaRestricoesCdaWa.vue?vue&type=template&id=45c4b17d&lang=pug"
import script from "./ModalJustificativaRestricoesCdaWa.vue?vue&type=script&lang=js"
export * from "./ModalJustificativaRestricoesCdaWa.vue?vue&type=script&lang=js"
import style0 from "./ModalJustificativaRestricoesCdaWa.vue?vue&type=style&index=0&id=45c4b17d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports